import React from 'react'
import { object, string } from 'prop-types'
import styled from 'styled-components'
import Card from '@taglivros/oef_componentes/build/components/card'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { formatValor, calcularParcelas } from '../../../utils/formatter/formatter'
import { MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, PLANO_ANUAL } from '../../../constants'
import LogoTAG from '../../../components/LogoTAG/LogoTAG'

const estiloCuradoria = `
  ul {
    border-color: ${StyleGuide.cores.azul};
  }

  .plano__brinde {
    color: ${StyleGuide.cores.azulEscuro};
  }
`

const estiloIneditos = `
  ul {
    border-color: ${StyleGuide.cores.laranja};
  }

  .plano__brinde {
    color: ${StyleGuide.cores.laranjaEscuro};
  }
`

const Preco = styled.h4`
  font-size: 23px;
  font-weight: bold;


  @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
    font-size: 18px;
  }
`

const WrapperCardPlano = styled.div`
  max-width: 330px;
  width: 100%;

  ul {
    border-left: 3px solid;
    margin-bottom: 10px;
    padding-left: 15px;

    li {
      ${StyleGuide.tipografia.textoPequeno}
      line-height: 1.75;
    }
  }

  img {
    height: auto;
    max-width: 100%;

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-bottom: 10px;
    }
  }

  p {
    margin: 0;
  }

  .plano__brinde {
    ${StyleGuide.boldFonte}

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      display: block;
      margin-top: 10px;
    }
  }

  .card__plano__conteudo {
    h3 {
      ${StyleGuide.boldFonte}
      font-size: 20px;

      @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
        font-size: 40px;
        margin-top: 20px;
      }
    }

    small {
      ${StyleGuide.tipografia.textoPequeno}
      color: ${StyleGuide.cores.cinza400};
    }

    p {
      @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
        margin: 10px 0;
      }
    }

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      align-items: center;
      display: flex;
      justify-content: space-around;
    }
  }

  ${( { modalidade } ) => modalidade === MODALIDADE_INEDITOS.slug ? estiloIneditos : estiloCuradoria}
`

const CardPlano = ( { modalidade, plano } ) => {
  const isIneditos = modalidade === MODALIDADE_INEDITOS.slug
  const isPlanoAnual = plano.tipo === PLANO_ANUAL.visualizacao
  const valorPorKit = calcularParcelas( plano.tipo, plano.valorTotal )

  return (
    <Card
      largura="330px"
      padding={ StyleGuide.isMobile() ? '15px' : '30px' }
    >
      <WrapperCardPlano modalidade={ modalidade }>
        <div className="card__plano__conteudo">
          <LogoTAG
            modalidade={ modalidade }
          />

          {
            !StyleGuide.isMobile() &&
            <ul>
              {
                isIneditos ?
                  MODALIDADE_INEDITOS.informacaoKit.map( info => <li key={ info }>{info}</li> )
                  : MODALIDADE_CURADORIA.informacaoKit.map( info => <li key={ info }>{info}</li> )
              }
            </ul>
          }

          <div>
            <Preco>
              {formatValor( { 'valor': valorPorKit } )}

              <small>/mês</small>
            </Preco>

            <p><small>+ taxa de entrega</small></p>
          </div>
        </div>

        {
          isPlanoAnual ? <p className="plano__brinde">Apenas para plano anual: ganhe um brinde exclusivo</p> : null
        }
      </WrapperCardPlano>
    </Card>
  )
}

CardPlano.propTypes = {
  'modalidade': string.isRequired,
  'plano': object.isRequired
}

export default CardPlano
